import { CustomCacheProvider } from 'app/context/custom-cached';
import { TrackingRequestProvider } from 'app/context/tracking-request';
import React from 'react';

const BookInspectionContainer = ({ children }) => {
  return (
    <TrackingRequestProvider>
      <CustomCacheProvider>{children}</CustomCacheProvider>
    </TrackingRequestProvider>
  );
};

export default BookInspectionContainer;
